import { ReactNode } from "react";
import { Text, TextProps } from "@chakra-ui/react";
import { IWfLinkVariantProps, WfLinkGhost } from "src/components/base/wf-link";
import { TIconComponent } from "src/components/icons";

export interface IIconLink {
    url: string;
    children: ReactNode;
    icon: TIconComponent;
    linkProps?: Omit<IWfLinkVariantProps, "href">;
    textProps?: Omit<TextProps, "as" | "ml">;
    className?: string | undefined;
}

export const LinkWithIcon = ({ icon: IconComponent, url, children, linkProps, textProps, className }: IIconLink) => (
    <WfLinkGhost href={url} verticalAlign="bottom" {...linkProps}>
        <IconComponent />
        <Text as="span" ml={0.5} verticalAlign="middle" {...textProps} className={className}>
            {children}
        </Text>
    </WfLinkGhost>
);

export const LinkWithIconTruncatable = ({ icon, url, children, linkProps, textProps, className }: IIconLink) => (
    <LinkWithIcon
        url={url}
        icon={icon}
        linkProps={{ maxW: "100%", alignItems: "center", display: "inline-flex", ...linkProps }}
        textProps={{ display: "block", noOfLines: 1, wordBreak: "break-word", ...textProps }}
        className={className}
    >
        {children}
    </LinkWithIcon>
);
